import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';

const config = {

    hiddenClass: style('hidden'),
};

export default class SpoilerBody extends React.Component {

    constructor(props) {

        super(props);

        this.nodes = { body: null };
    }

    static get propTypes() {

        return {

            /**
             * @property {any} children
             * spoiler content to be hidden
             */
            children: PropTypes.any,

            /**
             * @property {bool} isOpen
             * is the spoiler open by default
             */
            isOpen: PropTypes.bool,
        };
    }

    render() {

        return (
            <div className={ this.getClasses() } ref={ (node) => { this.nodes.body = node; } }>
                { this.props.children }
            </div>
        );
    }

    getNode() {

        return this.nodes.body;
    }

    /** private */ getClasses() {

        const classes = [];

        if (this.props.isOpen != true)
            classes.push(config.hiddenClass);

        return classes.join(' ');
    }

}